'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveRule;

function resolveRule(rule) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var renderer = arguments[2];

  if (rule instanceof Function) {
    return rule(props, renderer);
  }

  return rule;
}